"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MoveModal", {
  enumerable: true,
  get: function get() {
    return _MoveModal.MoveModal;
  }
});
var _MoveModal = require("./MoveModal");